import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { UISafePipeModule } from '@app/ui/pipes/safe/safe.module';

import { UIVideoComponent } from './video.component';

@NgModule({
	declarations: [UIVideoComponent],
	imports: [CommonModule, UISafePipeModule],
	exports: [UIVideoComponent],
})
export class UIVideoModule {}
